angular.module("tromanWeb").directive("ergoScroll", [function () {
    return {
        restrict: "A",
        link: function (_scope, element, _attributes, _ctrls) {

            function needsScroll(elm) {
                const rc = elm.getBoundingClientRect();

                if (rc.top < 0) return true;
                if (rc.left < 0) return true;

                const viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                if (rc.right > viewWidth) return true;

                const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                if (rc.viewWidth > viewHeight) return true;

                return false;
            }

            if (element.length > 0) {
                if (needsScroll(element[0])) {
                    element[0].scrollIntoView();
                }
            }
        }
    };
}]);